module.exports = __webpack_public_path__ + "static/media/logo.61cb158e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 10
// module chunks = 0